/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import Select from "react-select";
import config from "../../../config/config";
import { useSelector } from 'react-redux';
import { usePopupManager } from "../../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../../constants";
import axios from "axios";
import DashboardSection from "../../DashboardContainer/DashboardSection";
import DomainTile from "../../DomainTile/DomainTile";
import ReusableTable from "../../ReusableTable/ReusableTable";
import styles from "./DetailedPageComp.module.css";
import "./DetailedPageComp.css";

const weekOptions = [
  { value: "Select", label: "Select" },
  { value: "Week-1", label: "Week-1" },
  { value: "Week-2", label: "Week-2" },
  { value: "Week-3", label: "Week-3" },
  { value: "Week-4", label: "Week-4" },
];

const { API_BASE_URL } = config;

const DepartmentalPageDrilldown = () => {

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const { showPopup } = usePopupManager();

  const initialFilters = location.state || {
    entityData: [],
    yearData: [],
    monthData: [],
    weekData: [],
  };

  const [hasApplied, setHasApplied] = useState(false);

  const [filters, setFilters] = useState(initialFilters);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  const [entity, setEntity] = useState([]);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [week, setWeek] = useState(weekOptions[0]);

  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [departPageDrill, setDepartPageDrill] = useState(1)

  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1);
  const itemsPerPage = 100;
  const [selectedPage, setSelectedPage] = useState(1);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "20px",
      flexWrap: "wrap",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "50px",
      overflowY: "auto",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: "visible",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      overflowX: "auto",
      whiteSpace: "nowrap",
    }),
    option: (provided) => ({
      ...provided,
      padding: "8px 12px",
    }),
  };

  const handleEntityChange = (selected) => {
    const updatedEntity = selected || [];
    setEntity(updatedEntity);
    setFilters((prev) => ({ ...prev, entityData: updatedEntity }));
  };

  const handleYearChange = (selected) => {
    const updatedYear = selected || [];
    setYear(updatedYear);
    setFilters((prev) => ({ ...prev, yearData: updatedYear }));
  };

  const handleMonthChange = (selected) => {
    const updatedMonths = selected || [];
    setMonth(updatedMonths);
    setFilters((prev) => ({ ...prev, monthData: updatedMonths }));
  };

  const handleWeekChange = (selected) => {
    setWeek(selected);
    setFilters(prev => ({ ...prev, weekData: selected }));
  };

  const handleDepartmentPageChange = (page) => {
    setDepartPageDrill(page);
    fetchDepartmentalDrilldownData(page);
  };

  const handleApply = () => {

    const entityFilterData = entity?.map((e) => e?.value) || [];

    if (!entityFilterData || entityFilterData.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    setDepartPageDrill(1);
    fetchDepartmentalDrilldownData(1)
  }

  const fetchDepartmentalDrilldownData = async (page = departPageDrill) => {
    setdataLoading(true);
    try {
      const entityFilterData = entity?.map((e) => e?.value) || [];
      const yearFilterData = year?.map((y) => y?.value) || [];
      const monthFilterData = month?.map((m) => m?.value) || [];

      const limit = itemsPerPage;
      const offset = (page - 1) * limit;

      const response = await axios.post(`${API_BASE_URL}/api/idt-departmental-drilldown`,
        {
          entity: entityFilterData,
          year: yearFilterData,
          month: monthFilterData,
          limit: limit,
          offset: offset,
        },
        {
          headers: {
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          },
        }
      );

      setData(response.data.data);
      setTotalRecords(response.data.total);
    } catch (error) {
      console.error('Error fetching IDT Departmental Drilldown data:', error);
    } finally {
      setdataLoading(false);
    }
  };

  // const handleCSVDownload = () => {
  //   const csvHeader = columns.map((col) => col.header).join(",");
  //   const csvRows = data.map((row) =>
  //     columns
  //       .map((col) => `"${(row[col.accessor] || "").replace(/"/g, '""')}"`)
  //       .join(",")
  //   );
  //   const csvContent = [csvHeader, ...csvRows].join("\n");
  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = "Departmental Notices.csv";
  //   link.click();
  // };

  // DepartmentalPageDrilldown
  const handleCSVDownload = async () => {
    const entityFilterData = entity?.map((e) => e?.value) || [];
    const yearFilterData = year?.map((y) => y?.value) || [];
    const monthFilterData = month?.map((m) => m?.value) || [];

    const response = await axios.post(`${API_BASE_URL}/api/idt-departmental-drilldown`,
      {
        entity: entityFilterData,
        year: yearFilterData,
        month: monthFilterData,
        limit: totalRecords,
        offset: 0,
      },
      {
        headers: {
          Authorization: "Basic YWRtaW4xOjEyMw==",
        },
      }
    );

    const fullData = response.data.data || [];

    const csvHeader = columns.map((col) => col.header).join(",");
    const csvRows = fullData.map((row) =>
      columns.map((col) => `"${(row[col.accessor] ?? "").toString().replace(/"/g, '""')}"`).join(","));
    const csvContent = [csvHeader, ...csvRows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;", });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Departmental_Notices.csv";
    link.click();
  };

  const handleReset = () => {
    setEntity([]);
    setYear([]);
    setMonth([]);
    setWeek(weekOptions[0]);
    setFilters({
      entityData: [],
      yearData: [],
      monthData: [],
      weekData: [],
    });
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/idt-entity`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setEntityOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching idt-entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/idt-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setYearOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching idt-year options:', error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/idt-month`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setMonthOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching idt-month options:', error);
    }
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
    fetchMonthOptions();
  }, []);

  useEffect(() => {
    if (entityOptions.length && yearOptions.length && monthOptions.length) {

      if (filters.entityData && filters.entityData.length > 0) {
        const ent = entityOptions.filter((opt) =>
          filters.entityData.some((e) => e.value === opt.value)
        );
        if (ent.length > 0) setEntity(ent);
      }

      if (filters.yearData && filters.yearData.length > 0) {
        const yr = yearOptions.filter((opt) =>
          filters.yearData.some((y) => y.value === opt.value)
        );
        if (yr.length > 0) setYear(yr);
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptions.filter((opt) =>
          filters.monthData.some((m) => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }

      if (filters.entityData && filters.entityData.length > 0) {
        setTimeout(() => {
          setHasApplied(true);
        }, 1000);
      }
    }
  }, [entityOptions, yearOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  const columns = [
    { header: "Notice #", accessor: "notice" },
    { header: "Entity", accessor: "entity" },
    { header: "Description", accessor: "description" },
    { header: "Response Status", accessor: "response_status" },
    { header: "Category", accessor: "category" },
    { header: "Owner", accessor: "owner" },
    { header: "Due Date", accessor: "due_date" },
    { header: "Ageing", accessor: "ageing" },
    { header: "Comments", accessor: "comments" },
  ];

  const [dataLoading, setdataLoading] = useState(false);

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          {/* <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Week</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={week}
                onChange={setWeek}
                options={weekOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div> */}
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      <div>
        <div className="row">
          <div className="col-md-12">
            <DomainTile title="Departmental Notices" showBackButton={true} mainPagePath="/Indirect-Tax"
              detailState={filters} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DashboardSection title="" disableDetailView={true}>
              {/* <h2> tabel here</h2> */}
              <ReusableTable
                data={data}
                columns={columns}
                itemsPerPage={itemsPerPage}
                onPageChange={handleDepartmentPageChange}
                isCustomOpen={true}
                totalRecords={totalRecords}
                handleCSVDownload={handleCSVDownload}
                dataLoading={dataLoading}
              />
            </DashboardSection>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepartmentalPageDrilldown;
